module.exports = __webpack_public_path__ + "static/media/Welcome.8029ad72.svg";